import React, { Component } from "react";
import { Input, Form, Button } from "antd";

const { TextArea } = Input;

class AddTrackedKeywordsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: ""
    };
  }

  onChange = ({ target: { value } }) => {
    this.setState({ value });
  };
  handleSubmit = event => {
    event.preventDefault();
    this.props.onSubmit(this.state.value);
    this.setState({ value: "" });
  };
  render() {
    return (
      <Form
        className="add-tracked-keywords-form"
        layout="vertical"
        onSubmit={this.handleSubmit}
        style={{ padding: 20 }}>
        <p>
          Add your desired keywords for {this.props.domain} here. You can add them one by one, or add multiple keywords
          separated by comma.
        </p>
        <Form.Item>
          <TextArea
            value={this.state.value}
            onChange={this.onChange}
            placeholder="keyword1, keyword2, keyword3, etc"
            autoSize={{ minRows: 5, maxRows: 25 }}
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={this.props.isAddingTrackedKeywords}>
            Add keywords
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default AddTrackedKeywordsForm;
